export const BUY_SELL_SEO_SYSTEM_NAME: string = 'buySellSeoSystemName';
